import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Dropdown,
  DropdownButton,
  Spinner,
} from "react-bootstrap";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";

import OTPInput from "./OTPInput";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  RecaptchaVerifier,
  signInWithPhoneNumber,
  getAuth,
  OAuthProvider,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import DALogo from "../assets/images/DALogo.png";
import { useFirebaseApp } from "reactfire";

const provider = new OAuthProvider("microsoft.com");
provider.setCustomParameters({
  // Force re-consent.
  // prompt: "consent",
  tenant: "6e5646b8-64cf-4878-bda9-5a1023b136a1",
  // client_id: "c1c3ea7c-ed68-4a8a-9b7d-ee725c7d2925",
  // response_type: "id_token",
  // response_mode: "query",
  // redirect_uri: "https://vehicle-imaging.web.app/__/auth/handler",
  // Target specific email with login hint.
  login_hint: "user@duttongroup.com.au",
});
provider.addScope("User.Read.all");
// import PageViewLoggerComponent from "./PageViewLoggerComponent";

const styles = {
  body: {
    fontFamily: "Arial, sans-serif",
  },
  background: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100vw",
    height: "100vh",
    minHeight: "100vh",
    minWidth: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "radial-gradient(1200px 800px at 20% -20%, #1a2332 0%, #23304a 45%, #061421 100%)",
    overflow: "auto",
    zIndex: 1000,
  },
  loginContainer: {
    padding: "20px",
    background:
      "radial-gradient(600px 400px at 50% 30%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 60%, rgba(255,255,255,0.7) 100%)",
    borderRadius: "12px",
    boxShadow: "0 0 24px 0 rgba(31, 38, 135, 0.10)",
    backdropFilter: "blur(2px)",
    WebkitBackdropFilter: "blur(2px)",
  },
};

const allowedCountryCodes = ["+61", "+81"];

const LoginFormComponent = () => {
  const [phone, setPhone] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [resendRequestCount, setResendRequestCount] = useState(0);
  const [isOTPSubmitting, setIsOTPSubmitting] = useState(false);
  const [appVerifier, setAppVerifier] = useState(undefined);
  const [countryCode, setCountryCode] = useState(allowedCountryCodes[0]);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [email, setEmail] = useState("");
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [userIp, setUserIp] = useState("NA");

  const app = useFirebaseApp();
  const auth = getAuth(app);
  // const auth = useAuth();
  auth.languageCode = "en";

  const handleToggleEmailInput = () => {
    setShowEmailInput(!showEmailInput);
  };

  const handleChangeEmailSignin = (e) => {
    setEmail(e.target.value);
  };

  const onSignInSubmit = async () => {
    let phoneNumber = "";

    if (typeof appVerifier === "undefined") {
      console.log("Verifier is undefined");
      return;
    }

    if (typeof phone === "undefined" || phone?.toString().length < 8) {
      toast.error(`Please enter a valid mobile number ${phone}`);
      return;
    } else {
      phoneNumber = countryCode + phone.toString();
      toast.success(
        `You will receive an SMS to ${phoneNumber} with a one time pin`
      );
    }

    await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((cR) => {
        setConfirmationResult(cR);
        setResendRequestCount(resendRequestCount + 1);
      })
      .catch((e) => {
        console.log("phone, error", e);
        let message = "";

        switch (e.code) {
          case "auth/captcha-check-failed":
            message = "Captcha error";
            break;

          case "auth/too-many-requests":
            message =
              "Too many attempts from this computer, please wait and try again later";
            break;

          case "auth/invalid-phone-number":
            message = "Phone number format not recognised";
            break;

          case "auth/invalid-verification-code":
            message = "Invalid verification code";
            break;

          default:
            message = e.message;
        }
        toast.error(message);
      });
  };

  const resendOTP = () => {
    setResendRequestCount(resendRequestCount + 1);
    if (typeof appVerifier !== "undefined") {
      appVerifier.render().then((widgetId) => {
        // grecaptcha.reset(widgetId);
        setAppVerifier(widgetId);
        onSignInSubmit();
      });
    }
  };

  const handleChange = (e) => {
    setPhone(e.target.value);
  };

  const confirmOTP = (code) => {
    if (confirmationResult === null) {
      toast.error("Error with verification, please retry");

      return;
    } else if (typeof code === "undefined" || code.length < 6) {
      toast.error("Please enter 6 digit code");
      return;
    } else {
      setIsOTPSubmitting(true);
      const otpcode = code.toString();
      confirmationResult
        .confirm(otpcode)
        .then((result) => {})
        .catch((e) => {
          console.log("otp error", e);
          switch (e.code) {
            case "auth/user-disabled":
              toast.error(
                "Thank you for registering, an administrator will be in touch with you to enable your account once you are verified as an employee"
              );
              break;
            default:
              toast.error(e.message);
          }
          setIsOTPSubmitting(false);
        });
    }
  };

  // MSFT login
  const handleMicrosoftLogin = async () => {
    // toast.error(`Coming soon...`);
    // return;
    toast.success("Logging in with Microsoft");
    setIsSubmitting(true);
    try {
      // If dev mode, use signinwithpopup
      // if (window.location.hostname === "localhost") {
      return await signInWithPopup(auth, provider).then((result) => {
        toast.success("Login successful, redirecting to the portal...");
        setIsSubmitting(false);
      });
      // }
      // If prod mode, use signinwithredirect

      // await signInWithRedirect(auth, provider);

      // return await signInWithPopup(auth, provider)
      //   .then((result) => {
      //     // User is signed in.
      //     // IdP data available in result.additionalUserInfo.profile.
      //     console.log(result);
      //     // // Get the OAuth access token and ID Token
      //     const credential = OAuthProvider.credentialFromResult(result);
      //     const accessToken = credential.accessToken;
      //     const idToken = credential.idToken;
      //     return;
      //   })
      //   .catch((error) => {
      //     // Handle error.
      //     // console.log("error", error);
      //     // toast.error("Error logging into the Data Portal");
      //     toast.error(error.message);
      //   });
    } catch (e) {
      // console.log("error", e);
      toast.error("Error logging in");
      setIsSubmitting(false);
    }
  };

  // Initialise firebase recapthca

  useEffect(() => {
    // auth.appVerificationDisabledForTesting = true;
    // auth.settings.appVerificationDisabledForTesting = true;
    const tmpappVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
      callback: (response, err) => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        if (err) console.log("capt", err);
        onSignInSubmit();
      },
      "expired-callback": () => {
        console.log("expired");
      },
    });
    setAppVerifier(tmpappVerifier);
  }, []);

  useState(() => {
    if (confirmationResult !== null) {
    }
  }, [confirmationResult]);

  useEffect(() => {
    // Fetch user's IP address
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setUserIp(data.ip))
      .catch((error) => console.error("Error fetching IP address:", error));
  }, []);

  return (
    <div style={styles.background}>
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh", background: "none" }}
      >
        <Row style={{ width: "100%", justifyContent: "center" }}>
          <Col style={styles.loginContainer} md={6} lg={5} xl={4}>
            <Row>
              <Col>
                <img
                  src={DALogo}
                  alt="Dutton Data Portal"
                  style={{
                    width: "60%",
                    marginBottom: 40,
                    marginTop: 30,
                    maxWidth: 200,
                  }}
                />
                <h5
                  style={{
                    marginBottom: 30,
                    fontWeight: 400,
                    textAlign: "center",
                  }}
                >
                  <b
                    style={{
                      fontWeight: 400,
                      fontSize: 18,
                    }}
                  >
                    Sign in to continue
                  </b>
                </h5>
                <Button
                  variant="outline-dark"
                  onClick={() => handleMicrosoftLogin()}
                  style={{
                    padding: 15,
                    background: "rgba(255, 255, 255, 0.18)",
                    border: "1.5px solid rgba(255, 255, 255, 0.35)",
                    boxShadow: "0 4px 24px 0 rgba(31, 38, 135, 0.10)",
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    borderRadius: "12px",
                    color: "#222",
                    fontWeight: 450,
                    transition: "background 0.2s, color 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.28)";
                    e.target.style.color = "#111";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.18)";
                    e.target.style.color = "#222";
                  }}
                >
                  {isSubmitting ? (
                    <Spinner
                      animation="border"
                      role="status"
                      size="sm"
                      style={{ marginRight: 10 }}
                    />
                  ) : (
                    <svg
                      style={{ marginRight: 0 }}
                      height="20"
                      viewBox="0 0 20 20"
                      width="20"
                      fit=""
                      preserveAspectRatio="xMidYMid meet"
                      focusable="false"
                    >
                      <g fill="none">
                        <path d="M0 0h9.504v9.504H0z" fill="#F25022"></path>
                        <path
                          d="M10.496 0H20v9.504h-9.504z"
                          fill="#7FBA00"
                        ></path>
                        <path d="M0 10.496h9.504V20H0z" fill="#00A4EF"></path>
                        <path
                          d="M10.496 10.496H20V20h-9.504z"
                          fill="#FFB900"
                        ></path>
                      </g>
                    </svg>
                  )}
                  &nbsp;&nbsp; Log in with your Dutton ID
                </Button>
              </Col>
            </Row>
            <Row
              className="mt-5 text-left"
              style={{ fontSize: 12, color: "#6c757d" }}
            >
              <Col>
                A pop-out window will appear, please use your Dutton Group
                credentials to log in.
                <br />
                <br />
                If you have any issues, please contact IT support.
              </Col>
            </Row>
            <div id="recaptcha-container"></div>
            <Toaster />
            {/* <PageViewLoggerComponent /> */}
          </Col>
        </Row>
      </Container>
      {/* Add user's Ip as a div on bottom right in small font */}
      <div
        style={{
          position: "fixed",
          bottom: 10,
          right: 10,
          fontSize: 10,
          color: "#6c757d",
        }}
      >
        Your IP: {userIp}
      </div>
    </div>
  );
};

export default LoginFormComponent;
